// src/App.jsx - Art of Story Main Application

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';

// Layout
import Layout from './components/layout/Layout';
import PrivateRoute from './components/auth/PrivateRoute';

// Pages
import HomePage from './pages/HomePage';
import DashboardPage from './pages/DashboardPage';
import AssessmentPage from './pages/AssessmentPage';
import ModulesPage from './pages/ModulesPage';
import ModuleDetailPage from './pages/ModuleDetailPage';
import ToolkitPage from './pages/ToolkitPage';
import ResourcesPage from './pages/StorytellingResourcesPage';
import ProfilePage from './pages/ProfilePage';
import CompanionPage from './pages/CompanionPage';
import AuthCallback from './components/auth/AuthCallback';
import DataPrivacyPage from './pages/DataPrivacyPage';
import { DDD_TERMS_URL } from './config/legalLinks';
// Removed local auth pages - using centralised Auth Hub

// Styles
import './styles/globals.css';

// Terms are DDD-wide. /terms is kept so old links and bookmarks still work.
const ExternalRedirect = ({ to, label }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <p className="text-slate-300">
        Taking you to the <a href={to} className="text-amber-300 underline">{label}</a>…
      </p>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <Router>
            <Routes>
              {/* Back from the DDD Auth Hub: token exchange, outside the layout. */}
              <Route path="/auth/callback" element={<AuthCallback />} />

              {/* Public Routes */}
              <Route element={<Layout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/assessment" element={<AssessmentPage />} />
                <Route path="/modules" element={<ModulesPage />} />
                <Route path="/modules/:moduleId" element={<ModuleDetailPage />} />
                <Route path="/toolkit" element={<ToolkitPage />} />
                <Route path="/marlow" element={<CompanionPage />} />
                <Route path="/resources" element={<ResourcesPage />} />
                <Route path="/privacy" element={<DataPrivacyPage />} />
                <Route path="/terms" element={<ExternalRedirect to={DDD_TERMS_URL} label="Dive Deep Dialogues Terms of Use" />} />
                {/* Only profile requires authentication */}
                <Route path="/profile" element={
                  <PrivateRoute>
                    <ProfilePage />
                  </PrivateRoute>
                } />
              </Route>

              {/* Fallback */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;